"use client";

import clsx from "clsx";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import GailIcon from "../GailIcon";
import Button from "../library/Button";

type FooterProps = {
  footerDemoBtnPushToTop?: boolean;
};

const Footer = ({ footerDemoBtnPushToTop = false }: FooterProps) => {
  const { t } = useTranslation();

  const LINKS = [
    { href: "/product", label: t("header.product") },
    { href: "/pricing", label: t("header.pricing") },
    { href: "/compliance", label: t("header.compliance") },
    { href: "/privacy-policy", label: t("header.privacyPolicy") },
    { href: "/terms-conditions", label: t("header.termsCondition") },
    {
      href: process.env.NEXT_PUBLIC_GAIL_DASHBOARD_URL!,
      label: t("header.signIn"),
      className: "mt-6",
    },
  ];

  return (
    <footer className={clsx("bg-gail-primary pb-16")}>
      <div className={clsx("max-w-8xl mx-auto")}>
        <div
          className={clsx(
            "grid",
            "grid-cols-1",
            "lg:grid-cols-[1fr_200px]",
            "gap-4",
            "my-8 lg:mt-12",
            "lg:items-center",
            "px-4"
          )}
        >
          <div
            className={clsx(
              "mt-8 md:mt-0",
              "flex",
              "flex-col lg:flex-row",
              "text-4xl md:text-3xl xl:text-4xl",
              "font-medium",
              "text-center",
              "leading-none"
            )}
          >
            <h2 className={clsx("text-white")}>
              <a href={`/contact-sales`}>{t("footer.tryGailFree")}</a>
            </h2>
            <h2 className={clsx("text-[#6babff]")}>
              {t("footer.transformative")}
            </h2>
          </div>
          <div className={clsx("mb-12 md:mb-0")}>
            <Button
              type="tertiary"
              compact
              href={footerDemoBtnPushToTop ? undefined : `/contact-sales`}
              onClick={
                footerDemoBtnPushToTop
                  ? () => {
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }
                  : undefined
              }
              className="py-3 max-w-2xs mx-auto w-full"
            >
              {t("footer.requestDemo")}
            </Button>
          </div>
        </div>
        <hr className={clsx("border-[#4190df] mx-4 md:mx-0")} />
        <div
          className={clsx(
            "flex",
            "flex-row",
            "justify-between",
            "items-start",
            "pt-8"
          )}
        >
          <div className={clsx("ml-4")}>
            <GailIcon />
          </div>
          <nav className={clsx("flex", "flex-col", "max-w-1/2")}>
            {LINKS.map((link) => (
              <Link
                key={link.label}
                href={link.href}
                className={clsx(
                  "text-white",
                  "font-sans",
                  link.className,
                  "hover:text-[#C0C0C0]"
                )}
              >
                {link.label}
              </Link>
            ))}
            <div className={clsx("flex", "justify-end", "py-8")}>
              <p className={clsx("text-[10px]", "text-white/70")}>
                {t("footer.copyright")}
              </p>
            </div>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
